module.exports = __webpack_public_path__ + "static/media/ARI-STEVI Smart 440-441.af85a191.jpg";